import React from 'react';
import Alert from '../Utils/Alert';

export const Payment: React.FC = () => {
  return (
    <div style={{ width: '85%' }}>
      <Alert message="Payment section comming soon" returnHome={true} />
    </div>
  );
};
